import React from 'react'
import Dropdown from 'react-bootstrap/Dropdown';

function Createdroplist() {
  return (<>
  <Dropdown>
            <Dropdown.Toggle  className='dropdown-btns' variant="success" id="dropdown-basic">
                No Button
            </Dropdown.Toggle>

            <Dropdown.Menu className='mt-3 ps-2 pe-2 '>
                <Dropdown.Item className='drop_item' href="#/action-1">No Button</Dropdown.Item>
                <Dropdown.Item href="#/action-2" className='drop_item'>Book</Dropdown.Item>
                <Dropdown.Item href="#/action-3" className='drop_item'>Order online</Dropdown.Item>
                <Dropdown.Item href="#/action-3" className='drop_item'>Buy</Dropdown.Item>
                <Dropdown.Item href="#/action-3" className='drop_item'>Learn more</Dropdown.Item>
                <Dropdown.Item href="#/action-3" className='drop_item'>Sign Up</Dropdown.Item>
                <Dropdown.Item href="#/action-3" className='drop_item' style={{borderBottom:"none"}}>Call now</Dropdown.Item>
            
            </Dropdown.Menu>
        </Dropdown>
  
  
  
  
  
  
  
  
  </>
    
  )
}

export default Createdroplist